import { render, staticRenderFns } from "./ExamineeCensus.vue?vue&type=template&id=a099bc24&scoped=true&"
import script from "./ExamineeCensus.vue?vue&type=script&lang=js&"
export * from "./ExamineeCensus.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeCensus.vue?vue&type=style&index=0&id=a099bc24&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a099bc24",
  null
  
)

export default component.exports